import { createContext } from 'react'

const SectionContext = createContext()

const SectionProvider = ({ children, variation = {} }) => {
  return <SectionContext.Provider value={{ variation }}>{children}</SectionContext.Provider>
}

export { SectionProvider, SectionContext }
